import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M22 20v-9H2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M18 11V4H6v7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 22v-4a3 3 0 0 0-3-3v0a3 3 0 0 0-3 3v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 11V9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 11V9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 4V2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 4V2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 4V2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 4V2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Castle";
const Castle = memo(themed(Icon));
export {
  Castle
};
//# sourceMappingURL=castle.js.map
